import "core-js/modules/es6.object.keys.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

/* eslint-disable import/no-unresolved, import/no-extraneous-dependencies */
import middleware from '@@/.nuxt/middleware';

middleware['nuxt-custom-headers'] = function (context) {
  if (process.server) {
    var headers = [].concat.apply([], context.route.matched.map(function (_ref) {
      var components = _ref.components;
      return Object.values(components);
    })).reduce(function (headers, component) {
      if (component.options && component.options[context.env.NUXT_CUSTOM_HEADERS_FUNCTION]) {
        Object.assign(headers, component.options[context.env.NUXT_CUSTOM_HEADERS_FUNCTION](context));
      }

      return headers;
    }, {});
    Object.keys(headers).map(function (header) {
      context.res.setHeader(header, headers[header]);
    });
  }
};